import { Database, FileText, Plus } from '@ondit/ui/icons'
import { noop } from '@ondit/utils/helpers'
import {
  type BreadcrumbItem,
  type ChromeActionSpec,
  ResourceChromeFallback,
} from '@/screens/workspace/components'
import { FOLDERED_RESOURCE_HEADERS } from '@/screens/workspace/components/folders/foldered-resources'
import { useT } from '~/core/i18n'

const KNOWLEDGE_HEADER = FOLDERED_RESOURCE_HEADERS.knowledge_base

const COLUMNS = [
  { id: 'content', header: 'Content' },
  { id: 'index', header: 'Index', widthMultiplier: 0.6 },
  { id: 'tokens', header: 'Tokens', widthMultiplier: 0.6 },
  { id: 'status', header: 'Status', widthMultiplier: 0.75 },
]

const ACTIONS = [{ text: 'New chunk', icon: Plus, variant: 'primary' }] satisfies ChromeActionSpec[]

const BREADCRUMBS: BreadcrumbItem[] = [
  { label: KNOWLEDGE_HEADER.rootLabel, icon: Database, onClick: noop },
  { label: '…', icon: Database },
  { label: '…', terminal: true },
]

export default function DocumentLoading() {
  const t = useT()
  return (
    <ResourceChromeFallback
      icon={FileText}
      breadcrumbs={BREADCRUMBS}
      columns={COLUMNS.map((column) => ({ ...column, header: t(column.header) }))}
      actions={ACTIONS.map((action) => ({ ...action, text: t(action.text) }))}
      searchPlaceholder={t('Search chunks...')}
      hasSort
      hasFilter
    />
  )
}
